<template>
    <div class="details_container">
        <div class="qCard">
            <div class="title">{{ $t('agent.faqTitle1')}} <span>688V</span> ?</div>
            <div class="card_details"><span>688V</span> {{ $t('agent.faqContent1')}}</div>
        </div>
        <div class="qCard">
            <div class="title">{{ $t('agent.faqTitle2')}}</div>
            <div class="card_details">{{ $t('agent.faqContent2')}}</div>
        </div>
        <div class="qCard">
            <div class="title">{{ $t('agent.faqTitle3')}}</div>
            <div class="card_details">{{ $t('agent.faqContent3')}} <span>688V</span> {{ $t('agent.faqContent3Sub')}}</div>
        </div>
        <div class="qCard">
            <div class="title">{{ $t('agent.faqTitle4')}}</div>
            <div class="card_details">{{ $t('agent.faqContent4')}}</div>
        </div>
        <GraphCard :isShowNotice="true" :textColors="{ titleColor: '#f8e400', backgroundColor: '#232129' }" />
        <RuleCard />
        <div class="qCard">
            <div class="title">{{ $t('agent.definition')}}</div>
            <div class="card_details">{{ $t('agent.definitionContent')}}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import GraphCard from './graphCard.vue';
import RuleCard from './ruleCard.vue';

const resData = ref({
    details: [],
    page: 1,
    summary: {
        commission: 0,
        commission_rate: 0,
        total_bet: 0,
    },
    tip: "",
    totalPage: 1
});

</script>

<style scoped>
.details_container {
    padding: 15px;
}

.qCard {
    border-radius: 10px;
    background: #232129;
    /* border: 1px solid rgba(255, 255, 255, 0.15); */
    padding: 15px;
    margin-bottom: 10px;
    line-height: 20px;
}

.qCard span {
    color: #ffa600;
}

.title {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    text-align: center;
    justify-content: center;
    padding: 10px 0;
    color: #fd66b1;
}

.card_details {
    color: rgba(255, 255, 255, 0.85);
}
</style>